/* top-level nav "peel" hover - splits link text into per-character spans

   The split has to be re-applied outside the theme editor: sections/header.liquid
   hydrates on every ordinary load, re-fetching the header through the Section
   Rendering API ~4s in and morphing server HTML back over the live DOM, which
   replaces each title's contents with plain text (58 characters split at
   DOMContentLoaded, 0 after the morph). data-skip-node-update does not help -
   morph.js still descends into children - and morphSection dispatches no event,
   so the two hooks below re-apply it. split() is idempotent.

   The whole per-character structure is aria-hidden with one un-split
   .visually-hidden span carrying the real word: screen readers spell a run of
   one-letter spans out character by character. */

(function () {
  'use strict';

  var SELECTOR = '.header-menu .menu-list__link-title, .yg-footer-section .menu__item a';
  var CHARS = '.yg-nav-chars';
  var MENU = '.header-menu';
  var SECTION = '.header-section';
  var SPACE = String.fromCharCode(32);
  var NBSP = String.fromCharCode(160);

  function init() {
    var titles = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < titles.length; i++) {
      split(titles[i]);
    }
  }

  /**
   * @param {Element} title
   */
  function split(title) {
    if (title.querySelector(CHARS)) return;

    /* textContent returns the raw source text, including the Liquid template's
       whitespace around {{ link.title }} - not browser-collapsed once it is
       re-wrapped in white-space:pre spans below, so collapse it here. */
    var text = (title.textContent || '').trim().replace(/\s+/g, ' ');
    if (!text) return;

    var characters = document.createElement('span');
    characters.className = 'yg-nav-chars';
    characters.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < text.length; i++) {
      var char = text[i];
      var isSpace = char === SPACE;
      /* Non-breaking space, not a plain one: a lone space in its own span can
         collapse to zero width depending on white-space handling. */
      var display = isSpace ? NBSP : char;

      var wrap = document.createElement('span');
      wrap.className = 'yg-nav-char' + (isSpace ? ' yg-nav-char--space' : '');
      wrap.style.setProperty('--yg-char-index', String(i));

      var top = document.createElement('span');
      top.className = 'yg-nav-char__face yg-nav-char__face--top';
      top.textContent = display;

      var bottom = document.createElement('span');
      bottom.className = 'yg-nav-char__face yg-nav-char__face--bottom';
      bottom.textContent = display;

      wrap.appendChild(top);
      wrap.appendChild(bottom);
      characters.appendChild(wrap);
    }

    var label = document.createElement('span');
    label.className = 'visually-hidden';
    label.textContent = text;

    title.textContent = '';
    title.appendChild(characters);
    title.appendChild(label);
  }

  var menuObserver = null;

  /* nav - re-split after any header re-render */
  function observeMenu() {
    if (!window.MutationObserver) return;

    var menu = document.querySelector(MENU);
    if (!menu) return;

    if (!menuObserver) menuObserver = new MutationObserver(refresh);

    menuObserver.observe(menu, { childList: true, subtree: true });
  }

  /* Disconnected across the split so the observer never sees its own writes,
     then re-attached against whatever .header-menu is current - a wholesale
     replacement would leave the old registration on a detached element. */
  function refresh() {
    if (menuObserver) menuObserver.disconnect();

    init();
    observeMenu();
  }

  /* nav - one-shot watch on the header hydration morph */
  function watchHydration() {
    if (!window.MutationObserver) return;

    var section = document.querySelector(SECTION);
    if (!section) return;

    if (section.getAttribute('data-hydrated') === 'true') {
      refresh();
      return;
    }

    var observer = new MutationObserver(function () {
      if (section.getAttribute('data-hydrated') !== 'true') return;

      observer.disconnect();
      refresh();
    });

    observer.observe(section, { attributes: true, attributeFilter: ['data-hydrated'] });
  }

  function start() {
    refresh();
    watchHydration();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
